// react and js
import { React } from "react";
import { HelmetProvider } from "react-helmet-async";
import { BrowserRouter } from "react-router-dom";
import ReactDOM from "react-dom/client";

// mui

// components
import App from "./App";

// hooks

// i18n — must initialize before App is rendered
import "./i18n";
import { detectLanguageFromPath } from "./i18n/languages";

// layouts

// pages

// theme

// utils

// widgets

// ----------------------------------------------------------------------
// Code
// ----------------------------------------------------------------------
// Detect the language from the URL's first path segment.
// Non-English locales render under a basename ("/de", "/fr", …); English uses "/".
const { basename } = detectLanguageFromPath(window.location.pathname);

// ----------------------------------------------------------------------
// Properties
// ----------------------------------------------------------------------

// ----------------------------------------------------------------------
// Main element export(s)
// ----------------------------------------------------------------------
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <HelmetProvider>
    <BrowserRouter basename={basename}>
      <App />
    </BrowserRouter>
  </HelmetProvider>
);
